import { createAction } from "@reduxjs/toolkit";
import { NotificationModel } from "../../reducers/main/mainModel";

export const loadSchemas = createAction('loadSchemas');
export const loadTopSchemas = createAction('loadTopSchemas');
export const loadOpenedSchema = createAction<string>('loadOpenedSchema');
export const loadOpenedSchemaModels = createAction<string>('loadOpenedSchemaModels');
export const loadOpenedModel = createAction<string>('loadOpenedModel');
export const loadOpenedModelByName = createAction<{ name: string, schema: string }>('loadOpenedModelByName');

export const loadTrainedModels = createAction<string>('loadTrainedModels');
export const onThrowAlert = createAction<NotificationModel>('onThrowAlert');
export const closeErrorSaga = createAction<NotificationModel>('closeErrorSaga');

export type loadSchemasType = {
    offset: number,
    count: number
}

